import React, { memo, useContext, useEffect, useState } from 'react';
import {
  AccordionComponent,
  AccordionItemDirective,
  AccordionItemsDirective,
  SidebarComponent,
} from '@syncfusion/ej2-react-navigations';
import './Layout_responsive.css';
import './doc.css';
import { BrowserRouter, NavLink } from 'react-router-dom';
import 'react-jquery-plugin';
import { AiFillExperiment, AiFillSetting } from 'react-icons/ai';
import { GiMineTruck, GiNetworkBars, GiTrade } from 'react-icons/gi';
import { SiCloudsmith } from 'react-icons/si';
import './hamburger.css';
import {
  FaDiceD20,
  FaSignOutAlt,
  FaUsers,
  FaLayerGroup,
  FaCropAlt,
  FaCube,
  FaCalendarWeek,
  FaClock,
  FaRoute,
  FaThemeco,
} from 'react-icons/fa';

import { MdGroupWork, MdSupervisorAccount } from 'react-icons/md';
import RouterCustom from './RouterCustom';
import Header from './Header';
import useToken from '../../useToken';
import Login from '../LoginPage/Login/Login';
import { useDispatch, useSelector } from 'react-redux';
import { onLogOut } from '../../redux/auth.slice';
import Message from '../../utils/Message/Message';
import { RadioButtonComponent } from '@syncfusion/ej2-react-buttons';
import { setTheme } from '../../utils/theme';
import { ThemeContext } from '../../context/theme.context';
import App1, { all_information } from '../../App';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { setServer_gmt, setTimezoneOffset } from '../../redux/search.slice';
import { getLocalUtcOffSetValue } from '../../utils/Methods/methods';
import { store } from "../../store";
export const GetErpTypeFromConfig = () => {
  const state = store.getState();
  const erpType = state.search.erpType;
  return erpType;
};

interface IProps {
  fetchTheCurrentUser: (token: string) => void;
}
export const timezoneData = [
  { text: 'UTC -12:00', value: 'Etc/GMT+12' },
  { text: 'UTC -11:00', value: 'Etc/GMT+11' },
  { text: 'UTC -10:00', value: 'Etc/GMT+10' },
  { text: 'UTC -09:00', value: 'Etc/GMT+9' },
  { text: 'UTC -08:00', value: 'Etc/GMT+8' },
  { text: 'UTC -07:00', value: 'Etc/GMT+7' },
  { text: 'UTC -06:00', value: 'Etc/GMT+6' },
  { text: 'UTC -05:00', value: 'Etc/GMT+5' },
  { text: 'UTC -04:00', value: 'Etc/GMT+4' },
  { text: 'UTC -03:00', value: 'Etc/GMT+3' },
  { text: 'UTC -02:00', value: 'Etc/GMT+2' },
  { text: 'UTC -01:00', value: 'Etc/GMT+1' },
  { text: 'UTC +00:00', value: 'Etc/GMT' },
  { text: 'UTC +01:00', value: 'Etc/GMT-1' },
  { text: 'UTC +02:00', value: 'Etc/GMT-2' },
  { text: 'UTC +03:00', value: 'Etc/GMT-3' },
  { text: 'UTC +04:00', value: 'Etc/GMT-4' },
  { text: 'UTC +05:00', value: 'Etc/GMT-5' },
  { text: 'UTC +05:30', value: 'Etc/GMT-5.3' },
  { text: 'UTC +06:00', value: 'Etc/GMT-6' },
  { text: 'UTC +07:00', value: 'Etc/GMT-7' },
  { text: 'UTC +08:00', value: 'Etc/GMT-8' },
  { text: 'UTC +09:00', value: 'Etc/GMT-9' },
  { text: 'UTC +10:00', value: 'Etc/GMT-10' },
  { text: 'UTC +11:00', value: 'Etc/GMT-11' },
  { text: 'UTC +12:00', value: 'Etc/GMT-12' },
  { text: 'UTC +13:00', value: 'Etc/GMT-13' },
  { text: 'UTC +14:00', value: 'Etc/GMT-14' },
];
let theTZDropDown: DropDownListComponent;
export function SidebarWithMenu({ fetchTheCurrentUser }: IProps) {
  var dockBar: SidebarComponent = new SidebarComponent({});
  const context = useContext(ThemeContext);
  const [isTimeZoneChanged, setisTimeZoneChanged] = useState<boolean>(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [currentTheme, setCurrentTheme] = useState<string | null | undefined>(
    'dark'
  );
  const [tzValue, setTzValue] = useState<string>('');
  let timezone_offset = useSelector((state: any) => state.search.timezone_offset);
  const ERP_TYPE = GetErpTypeFromConfig();

  const dispatch = useDispatch();
  const dockSize: string = '72px';
  const width: string = '220px';
  let justOnce: boolean = false;
  const onCreated = () => {
    //if (dockBar) dockBar?.toggle();
    // setIsDrawerOpen(false);
  };
  const toggleClick = () => {
    $('.hamburger-container').toggleClass('change');
    dockBar.toggle();
    setIsDrawerOpen(!isDrawerOpen);
  };
  useEffect(() => {
    // setIsDrawerOpen(dockBar.isOpen);
  }, [dockBar.isOpen]);
  useEffect(() => {
    let theTzValue = localStorage.getItem('tzDrawer');
    if (theTzValue !== '' && theTzValue !== null) {
      setTzValue(theTzValue);
      context.setTimezone(theTzValue);
    }
    dispatch(setTimezoneOffset(getLocalUtcOffSetValue()));
  }, [isTimeZoneChanged]);

  var pathArray = [];
  useEffect(() => {
    if (ERP_TYPE === 'MEX') {
      // if(ERP_TYPE !== 'MEX'){
      //   dispatch(setTimezoneOffset(0));
      // }

      let theTzValue = localStorage.getItem('tzDrawer');

      if (theTzValue !== '' && theTzValue !== null) {

        setTzValue(theTzValue);
        context.setTimezone(theTzValue);
      }
    }

    let theTheme = localStorage.getItem('theme');

    if (theTheme === '' || theTheme === null) {
      setCurrentTheme('theme-dark');
      setTheme('theme-dark');
      context.setTeamValue(true);
    } else {
      setCurrentTheme(theTheme);
      setTheme(theTheme ? theTheme : '');
    }
    if (theTheme?.includes('light')) {
      context.setTeamValue(false);
    }
    let thePathToCheckOut = window.location.pathname.split('/');
    if (
      !isCheckedPermission(thePathToCheckOut[1]) &&
      thePathToCheckOut[1] !== ''
    ) {
      var newURL = window.location.protocol + '//' + window.location.host;
      window.location.href = newURL;
      return;
    }
    $('.sidebar-item.child').click(function () {
      const scope = $(this);
      var title = (scope[0].children[0] as any).title;
      $('.title-head').html(title);
    });
    if (!window.location.pathname.includes('settings')) {
      if (justOnce) {
        var newURL =
          window.location.protocol +
          '//' +
          window.location.host +
          '/clouddiscovery';
        window.location.href = newURL;
        justOnce = false;
      }
    } else {
      pathArray = window.location.pathname.split('/');
    }

    if (pathArray.length >= 3) {
      var newURL =
        window.location.protocol + '//' + window.location.host + '/settings';
      window.location.href = newURL;
    }
  }, []);
  const { token } = useToken();
  const onLogout = () => {
    dispatch(onLogOut());
    Message.info('Success');
  };
  if (!token) {
    Message.warning('Access Denied..');
    return <Login fetchTheCurrentUser={fetchTheCurrentUser} />;
  }
  const onTheThemeSelection = (args: any) => {
    if (args.value === 'light1') {
      setTheme('theme-light');
      setCurrentTheme('theme-light');
      if (currentTheme?.includes('dark')) {
        context.setTeamValue(false);
      }
    } else if (args.value === 'dark1') {
      setTheme('theme-dark');
      setCurrentTheme('theme-dark');
      if (currentTheme?.includes('light')) {
        context.setTeamValue(true);
      }
    } else if (args.value === 'dark2') {
      setTheme('theme-dark-small');
      setCurrentTheme('theme-dark-small');
      if (currentTheme?.includes('light')) {
        context.setTeamValue(true);
      }
    } else if (args.value === 'light2') {
      setTheme('theme-light-small');
      setCurrentTheme('theme-light-small');
      if (currentTheme?.includes('dark')) {
        context.setTeamValue(false);
      }
    }
  };
  const onChangeTimezone = (args: any) => {
    // setTzValue(args.value);
    localStorage.setItem('tzDrawer', args.value);
    console.log("zone: ", getLocalUtcOffSetValue())
    const timezoneOffset = getLocalUtcOffSetValue();
    dispatch(setTimezoneOffset(timezoneOffset));
    const gmt = timezoneOffset ? timezoneOffset / -60 : 11;
    dispatch(setServer_gmt(gmt))
    context.setTimezone(args.value);
    setisTimeZoneChanged((prevState) => !prevState);
    theTZDropDown && (theTZDropDown.value = tzValue);
  };
  const tzSelectionContent = () => {
    return (
      <div>
        <DropDownListComponent
          dataSource={timezoneData}
          fields={{ text: 'text', value: 'value' }}
          value={tzValue}
          showClearButton={true}
          filterBarPlaceholder='Search a shift'
          onChange={onChangeTimezone}
          placeholder='Timezone'
          floatLabelType='Always'
          ref={(theRef: DropDownListComponent) => {
            theTZDropDown = theRef;
            theTZDropDown && (theTZDropDown.value = tzValue);
          }}
        />
      </div>
    );
  };
  const themeSelectionContent = () => {
    return (
      <div className='theme-selection-content'>
        <div className='theme-selection-content-each-radio'>
          <RadioButtonComponent
            label='Dark'
            name='theme'
            checked={currentTheme === 'theme-dark'}
            onChange={onTheThemeSelection}
            value='dark1'
          ></RadioButtonComponent>
        </div>
        <div className='theme-selection-content-each-radio'>
          <RadioButtonComponent
            label='Light'
            name='theme'
            value='light1'
            checked={currentTheme === 'theme-light'}
            onChange={onTheThemeSelection}
          ></RadioButtonComponent>
        </div>
        <div className='theme-selection-content-each-radio'>
          <RadioButtonComponent
            label='Light Small'
            name='theme'
            onChange={onTheThemeSelection}
            value='light2'
            checked={currentTheme === 'theme-light-small'}
          ></RadioButtonComponent>
        </div>
        <div className='theme-selection-content-each-radio'>
          <RadioButtonComponent
            label='Dark Small'
            name='theme'
            onChange={onTheThemeSelection}
            checked={currentTheme === 'theme-dark-small'}
            value='dark2'
          ></RadioButtonComponent>
        </div>
      </div>
    );
  };
  const isCheckedPermission = (name: string) => {
    let theComponents: Array<any> = all_information.theComponents;
    let theRole = all_information.isAdminRole;
    let theActualName = cleanUpTheString(name);
    if (theComponents.length > 0 && !theRole) {
      let theResult = theComponents.findIndex(
        (el: any) => cleanUpTheString(el.component_name) === theActualName
      );
      if (theResult !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  const cleanUpTheString = (name: string) => {
    return name.replace(/\s/g, '').trim().toLocaleLowerCase('en-US');
  };
  return (
    <BrowserRouter>
      <div className='container-fluid control-section sidebar-menu'>
        <div>
          <Header onClickToggle={toggleClick} isDrawerOpen={isDrawerOpen} />
          <div className='col-lg-12 col-sm-12 col-md-12'>
            <SidebarComponent
              id='dockSidebar'
              ref={(Sidebar: SidebarComponent) => {
                dockBar = Sidebar;
              }}
              created={onCreated}
              enableDock={true}
              dockSize={dockSize}
              width={width}
              enableGestures={false}
            >
              <div className='dock'>
                <ul>
                  <div className='sidebar-vertical-first'>
                    <NavLink
                      to='/'
                      className={
                        isCheckedPermission('ControlCenter')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html('Control Centre');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission('ControlCenter')
                          ? 'auto'
                          : 'none',
                      }}
                    >
                      <li className='sidebar-item child defaultActive'>
                        <span title='Control Centre' className='e-icons'>
                          <FaCropAlt
                            className='sidebar-icon'
                            size='17px'
                            title='Control Centre'
                          />
                        </span>
                        <span className='e-text ' title='Control Centre'>
                          Control Centre
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to='clouddiscovery'
                      className={
                        isCheckedPermission('CloudDiscovery')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html('Cloud Discovery');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission('CloudDiscovery')
                          ? 'auto'
                          : 'none',
                      }}
                    >
                      <li className='sidebar-item child'>
                        <span title='Cloud Discovery' className='e-icons'>
                          <FaCube
                            className='sidebar-icon'
                            size='17px'
                            title='Cloud Discovery'
                          />
                        </span>
                        <span className='e-text' title='Cloud Discovery'>
                          Cloud Discovery
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to='cloudplanner'
                      className={
                        isCheckedPermission('CloudPlanner')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html('Cloud Planner');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission('CloudPlanner')
                          ? 'auto'
                          : 'none',
                      }}
                    >
                      <li className='sidebar-item child'>
                        <span title='Cloud Planner' className='e-icons '>
                          <FaCalendarWeek
                            className='sidebar-icon'
                            size='17px'
                            title='Cloud Planner'
                          />
                        </span>
                        <span className='e-text' title='Cloud Planner'>
                          Cloud Planner
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to="cloudscheduler"
                      className={({ isActive }) =>
                        isCheckedPermission('CloudScheduler') ? (isActive ? 'active' : '') : 'deactive'
                      }
                      style={{
                        textDecoration: 'none',
                      }}
                    >
                      <li
                        className={`sidebar-item child ${isCheckedPermission('CloudScheduler') ? '' : 'disabled'
                          }`}
                      >
                        <span title="Cloud Scheduler" className="e-icons">
                          <FaClock
                            className="sidebar-icon"
                            size="17px"
                            title="Cloud Scheduler"
                          />
                        </span>
                        <span className="e-text" title="Cloud Scheduler">
                          Cloud Scheduler
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to='cloudexecution'
                      className={
                        isCheckedPermission('CloudExecution')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html('Cloud Execution');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission('CloudExecution')
                          ? 'auto'
                          : 'none',
                      }}
                    >
                      <li className='sidebar-item child'>
                        <span title='Cloud Execution ' className='e-icons'>
                          <FaDiceD20
                            className='sidebar-icon'
                            size='17px'
                            title='Cloud Execution'
                          />
                        </span>
                        <span className='e-text' title='Cloud Execution'>
                          Cloud Execution
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to='closecompliance'
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission('Close, Comp.Rep.')
                          ? 'auto'
                          : 'none',
                      }}
                      className={
                        isCheckedPermission('Close, Comp.Rep.')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html('Close, Comp.Rep.');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                    >
                      <li className='sidebar-item child'>
                        <span
                          title=' Close Complience and Reporting'
                          className='e-icons'
                        >
                          <GiNetworkBars
                            className='sidebar-icon'
                            size='17px'
                            title='Close, Comp.Rep.'
                          />
                        </span>
                        <span className='e-text' title='Close, Comp.Rep.'>
                          Close, Comp.Rep.
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to='tradeplanner'
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission('Trade Planner')
                          ? 'auto'
                          : 'none',
                      }}
                      className={
                        isCheckedPermission('Trade Planner')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html('Trade Planner');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                    >
                      <li className='sidebar-item child'>
                        <span title='Trade Planner' className='e-icons'>
                          <GiTrade
                            className='sidebar-icon'
                            size='17px'
                            title='  Trade Planner'
                          />
                        </span>
                        <span className='e-text' title='Trade Planner'>
                          Trade Planner
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to='tradesperson'
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission('Trades Person')
                          ? 'auto'
                          : 'none',
                      }}
                      className={
                        isCheckedPermission('Trades Person')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html('Trades Person');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                    >
                      <li className='sidebar-item child'>
                        <span title='Trades Person' className='e-icons'>
                          <FaUsers
                            className='sidebar-icon'
                            size='17px'
                            title='Trades Person'
                          />
                        </span>
                        <span className='e-text' title='Trades Person'>
                          Trades Person
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to=' assetintelligence'
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission('Asset Intelligence')
                          ? 'auto'
                          : 'none',
                      }}
                      className={
                        isCheckedPermission('Asset Intelligence')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html('Asset Intelligence');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                    >
                      <li className='sidebar-item child'>
                        <span title='Asset Intelligence' className='e-icons'>
                          <GiMineTruck
                            className='sidebar-icon'
                            size='19px'
                            title='Asset Intelligence'
                          />
                        </span>
                        <span className='e-text' title='Asset Intelligence'>
                          Asset Intelligence
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to='cloudproductiontracking'
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission(
                          'Cloud Production Tracking'
                        )
                          ? 'auto'
                          : 'none',
                      }}
                      className={
                        isCheckedPermission('Cloud Production Tracking')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html(
                                'Cloud Production Tracking'
                              );
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                    >
                      <li className='sidebar-item child'>
                        <span
                          title='Cloud Production Tracking'
                          className='e-icons'
                        >
                          <SiCloudsmith
                            className='sidebar-icon'
                            size='19px'
                            title='Cloud Production Tracking'
                          />
                        </span>
                        <span
                          className='e-text'
                          title='Cloud Production Tracking'
                        >
                          {'Cloud Production Tracking'.length >= 15
                            ? 'Cloud Production Tracking'.substring(0, 15) +
                            '...'
                            : 'Cloud Production Tracking'}
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to='shiftworkbench'
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission('Shift Workbench')
                          ? 'auto'
                          : 'none',
                      }}
                      className={
                        isCheckedPermission('Shift Workbench')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html('Shift Workbench');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                    >
                      <li className='sidebar-item child'>
                        <span title='Shift Workbench' className='e-icons'>
                          <MdGroupWork
                            className='sidebar-icon'
                            size='19px'
                            title='Shift Workbench'
                          />
                        </span>
                        <span className='e-text' title='Shift Workbench'>
                          Shift Workbench
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to='mntStrategies'
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission(
                          'Maintenance Strategies'
                        )
                          ? 'auto'
                          : 'none',
                      }}
                      className={
                        isCheckedPermission('Maintenance Strategies')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html('Maintenance Strategies');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                    >
                      <li className='sidebar-item child'>
                        <span
                          title='Maintenance Strategies'
                          className='e-icons'
                        >
                          <AiFillExperiment
                            className='sidebar-icon'
                            size='19px'
                            title='Maintenance Strategies'
                          />
                        </span>
                        <span className='e-text' title='Maintenance Strategies'>
                          {'Maintenance Strategies'.length >= 15
                            ? 'Maintenance Strategies'.substring(0, 15) + '...'
                            : 'Maintenance Strategies'}
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to='assetCModel'
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission('Asset Cost Model')
                          ? 'auto'
                          : 'none',
                      }}
                      className={
                        isCheckedPermission('Asset Cost Model')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html('Asset Cost Model');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                    >
                      <li className='sidebar-item child'>
                        <span title='Asset Cost Model' className='e-icons'>
                          <FaRoute
                            className='sidebar-icon'
                            size='19px'
                            title='Asset Cost Model'
                          />
                        </span>
                        <span className='e-text' title='Asset Cost Model'>
                          Asset Cost Model
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to='superVisorControlHub'
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission(
                          'Supervisor Control Hub'
                        )
                          ? 'auto'
                          : 'none',
                      }}
                      className={
                        isCheckedPermission('Supervisor Control Hub')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html('Asset Cost Model');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                    >
                      <li className='sidebar-item child'>
                        <span
                          title='Supervisor Control Hub'
                          className='e-icons'
                        >
                          <MdSupervisorAccount
                            className='sidebar-icon'
                            size='19px'
                            title='Supervisor Control Hub'
                          />
                        </span>
                        <span className='e-text' title='Supervisor Control Hub'>
                          {'Supervisor Control Hub'.length >= 15
                            ? 'Supervisor Control Hub'.substring(0, 16) + '...'
                            : 'Supervisor Control Hub'}
                        </span>
                      </li>
                    </NavLink>
                    {isDrawerOpen ? (
                      <li
                        className='child'
                        style={{ display: isDrawerOpen ? 'unset' : 'none' }}
                      >
                        <AccordionComponent expandMode='Single' style={{ marginTop: 16 }}>
                          <AccordionItemsDirective>
                            <AccordionItemDirective
                              header={() => {
                                return (
                                  <div
                                    style={{
                                      marginTop: 10,
                                      marginLeft: -10,
                                    }}
                                  >
                                    Appearance
                                  </div>
                                );
                              }}
                              iconCss='e-style'
                              content={themeSelectionContent}
                              expanded={false}
                            />
                            {/* {
                              ERP_TYPE === 'MEX' ? (
                                {} <AccordionItemDirective
                                  header={() => {
                                    return (
                                      <div
                                        style={{
                                          marginTop: 10,
                                          marginLeft: -10,
                                        }}
                                      >
                                        Localization
                                      </div>
                                    );
                                  }}
                                  iconCss='e-settings'
                                  content={tzSelectionContent}
                                  expanded={true}
                                /> }
                              ) : (
                                <></>
                                // <AccordionItemDirective
                                //   disabled
                                //   header={() => {
                                //     return (
                                //       <div
                                //         style={{
                                //           marginTop: 10,
                                //           marginLeft: -10,
                                //         }}
                                //       >
                                //         Localization
                                //       </div>
                                //     );
                                //   }}
                                //   iconCss='e-settings'
                                //   content={tzSelectionContent}
                                //   expanded={true}
                                // />
                              )
                            } */}
                          </AccordionItemsDirective>
                        </AccordionComponent>
                      </li>
                    ) : null}
                  </div>
                </ul>
                <div className='sidebar-vertical-second'>
                  <ul>
                    <NavLink
                      to='dig'
                      style={{
                        textDecoration: 'none',
                        pointerEvents: isCheckedPermission(
                          'DIG - Data Integration Gateway'
                        )
                          ? 'auto'
                          : 'none',
                      }}
                      className={
                        isCheckedPermission('DIG - Data Integration Gateway')
                          ? ({ isActive }) => {
                            isActive &&
                              $('.title-head').html(
                                'DIG - Data Integration Gateway'
                              );
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                    >
                      <li className='sidebar-item child'>
                        <span
                          title='DIG - Data Integration Gateway'
                          className='e-icons'
                        >
                          <FaLayerGroup
                            className='sidebar-icon'
                            size='17px'
                            title='Dig'
                          />
                        </span>
                        <span
                          className='e-text'
                          title='DIG - Data Integration Gateway'
                        >
                          {'DIG - Data Integration Gateway'.length >= 15
                            ? 'DIG - Data Integration Gateway'.substring(
                              0,
                              17
                            ) + '...'
                            : 'DIG - Data Integration Gateway'}
                        </span>
                      </li>
                    </NavLink>
                    <NavLink
                      to='settings/eventStatus'
                      style={{
                        textDecoration: 'none',
                        pointerEvents: all_information.isAdminRole
                          ? 'auto'
                          : 'none',
                      }}
                      className={
                        isCheckedPermission('Settings')
                          ? ({ isActive }) => {
                            isActive && $('.title-head').html('Settings');
                            return isActive ? 'active' : '';
                          }
                          : 'deactive'
                      }
                    >
                      <li className='sidebar-item child'>
                        <span title='Settings' className='e-icons'>
                          <AiFillSetting
                            className='sidebar-icon'
                            size='17px'
                            title='Settings/'
                          />
                        </span>
                        <span className='e-text' title='Settings'>
                          Settings
                        </span>
                      </li>
                    </NavLink>

                    <li className='sidebar-item child' onClick={onLogout}>
                      <span title='Logout' className='e-icons'>
                        <FaSignOutAlt
                          className='sidebar-icon'
                          size='17px'
                          title='Logout'
                        />
                      </span>
                      <span className='e-text' title='Logout'>
                        Logout
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </SidebarComponent>
            <div className='main-content' id='maintext'>
              <div className='sidebar-menu-content'>
                <RouterCustom />
              </div>
            </div>
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default memo(SidebarWithMenu);